// @flow
import React from 'react';

import { EditRenderer } from '../../../views/grid-utils/renderers';

import { SPTableFlowConfigurationAddEditModal } from './SPTableFlowConfigurationAddEditModal';

export const SPTableFlowEditRenderer = ({ data }) => {
  return (
    <EditRenderer>
      {(isEditModalOpen, setEditModalOpen) => {
        return (
          <SPTableFlowConfigurationAddEditModal
            initialValues={data}
            isEditingMode={true}
            isOpen={isEditModalOpen}
            setOpen={setEditModalOpen}
          />
        );
      }}
    </EditRenderer>
  );
};
